var exports = {
  "KC": "AuthorizedAppsTab.module__appList___dTFmai",
  "Um": "AuthorizedAppsTab.module__appCard___dTFmai",
  "sK": "AuthorizedAppsTab.module__appCardSelectable___dTFmai",
  "nD": "AuthorizedAppsTab.module__appMain___dTFmai",
  "tR": "AuthorizedAppsTab.module__appActions___dTFmai",
  "FG": "AuthorizedAppsTab.module__appAvatar___dTFmai",
  "O5": "AuthorizedAppsTab.module__appAvatarImage___dTFmai",
  "Q2": "AuthorizedAppsTab.module__appAvatarPlaceholder___dTFmai",
  "fI": "AuthorizedAppsTab.module__textBlock___dTFmai",
  "JB": "AuthorizedAppsTab.module__appName___dTFmai",
  "v8": "AuthorizedAppsTab.module__metaText___dTFmai",
  "gb": "AuthorizedAppsTab.module__iconButton___dTFmai",
  "R5": "AuthorizedAppsTab.module__revokeButton___dTFmai",
  "gE": "AuthorizedAppsTab.module__actionIcon___dTFmai",
  "Qn": "AuthorizedAppsTab.module__selectionHint___dTFmai",
  "Jb": "AuthorizedAppsTab.module__scopeList___dTFmai",
  "DL": "AuthorizedAppsTab.module__scopeTag___dTFmai",
  "OK": "AuthorizedAppsTab.module__scopeName___dTFmai",
  "RJ": "AuthorizedAppsTab.module__scopeDescription___dTFmai",
  "g4": "AuthorizedAppsTab.module__loadingContainer___dTFmai",
};

module.exports = exports;
